var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoinFill = function SvgCoinFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.9 12v1.8c0 2.983-4.432 5.4-9.9 5.4-5.37 0-9.742-2.331-9.896-5.24L2.1 13.8V12c0 2.983 4.432 5.4 9.9 5.4s9.9-2.417 9.9-5.4M12 4.8c5.468 0 9.9 2.418 9.9 5.4s-4.432 5.4-9.9 5.4-9.9-2.417-9.9-5.4c0-2.982 4.432-5.4 9.9-5.4"
  })));
};
export default SvgCoinFill;